import {
  USER_REGISTER_LOADING,
  USER_REGISTER_SUCCESS,
  USER_REGISTER_FAILURE,
} from "redux/types";
import { Dispatch } from "redux";
import { createNewItemService } from "services/createNewItemService";
import { notification } from "antd";
import { userRegisterUrl } from "api/apiUrls";

export const userRegisterAction =
  (data: any, callback?: any) => async (dispatch: Dispatch) => {
    try {
      dispatch({ type: USER_REGISTER_LOADING, payload: true });
      const response: any = await createNewItemService(
        `${userRegisterUrl}`,
        data,
        "",
        "json"
      );

      // console.log(response);

      if (response.status === 200) {
        dispatch({ type: USER_REGISTER_SUCCESS, payload: response.data });
        notification.success({
          message: `${response?.data?.full_name}!, successfully registered`,
        });
        callback();
      } else {
        notification.error({
          message: `${response?.response?.data?.Message}`,
        });
      }
    } catch (err) {
      dispatch({ type: USER_REGISTER_FAILURE, payload: err });
    } finally {
      dispatch({ type: USER_REGISTER_LOADING, payload: false });
    }
  };
